








import Vue from "vue";
import Component from "vue-class-component";

@Component({
  components: {},
})
export default class App extends Vue {
  public mounted() {
    document.documentElement.addEventListener(
      "touchstart",
      function (e) {
        if (e.touches.length >= 2) {
          e.preventDefault();
        }
      },
      { passive: false }
    );
    this.setVh();
    window.addEventListener("resize", () => {
      this.setVh();
    });
  }
  public setVh() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  }
}
